import React from 'react'

function OpticleanInstallation() {
  return (
    <embed src="\pdfs\E_1.10.1_K250e_Opticlean_Metal_ceiling_12.2018.pdf" width="100%" height="2100px" />
  )
}

export default OpticleanInstallation